module.exports = __webpack_public_path__ + "static/media/19ESCAP5.bad7c704.jpg";